import { request } from "./request";
import Cookies from "js-cookie";
import {
  COS_IMG_ADDRESS,
  getAppID,
  getFbPixelId,
  getStoredAdId,
  getStoredUserId,
  getTtPixelId,
  isTtChannel,
  setUserInfo
} from '@/utils/base'
import { getParam } from '@/utils/tools'
import { getRandomString } from "@/utils/paypal";
import { Toast } from 'vant'
import { toast, closeToast } from '@/components/pay/toast.js'
import loadImage from 'blueimp-load-image'

export const fetchGetTmpUuid = function (data) {
  return new Promise((resolve, reject) => {
    request({
      url: "/api/v1/user/tmp_register",
      method: "post",
      isToast: false,
      data: {
        app_id: getAppID(),
        user_type: 0
      },
    }).then(response => {
      setUserInfo(response.token_info.user_id, response.token_info.accessToken)
      resolve(response)
    }).catch(reject)
  })
}


// 获取档位列表
export const fetchGearList = function (data, isLoading = true) {
  return request({
    url: "/api/v1/order/purchase_list",
    method: "post",
    data,
    isToast: isLoading,
    isClearToast: 'none'
  })
}


export const fetchOrderSubmit = function (data) {
  return request({
    url: "/api/v1/alipay/submit",
    method: "post",
    responseType: 'all',
    isToast: true,
    data: {
      cid: getParam('pid') || '130500',
      cmid: getRandomString(),
      ...data,
    },
  })
}

export const fetchPaypalAppleCapture = function (data) {
  return request({
    url: '/api/v1/order/applepaypalcapture',
    method: 'post',
    data: {
      cmid: getRandomString(),
      ...data,
    },
  })
}

export const fetchGetUserDetail = function (data) {
  return request({
    url: "/api/v1/user/detail",
    method: "post",
    isToast: false,
    isClearToast: 'none',
    data,
  })
}

export const fetchQuestionTicketCreate = function (data) {
  return request({
    url: "/api/v1/question/ticket_create",
    method: "post",
    isToast: false,
    isClearToast: 'none',
    data,
  })
}

export const fetchQuestionAnswerGet = function () {
  return request({
    url: "/api/v1/question/answer_get",
    method: "post",
    isToast: false,
  })
}

export const fetchPixelReport = function (data, type = '') {
  if (isTtChannel()) {
    fetchTtReport(data, type)
  } else {
    fetchFbReport(data, type)
  }
}


export const fetchFbReport = function (data, type = '') {
  const obj = {
    app_id: getAppID(),
    lan: window.navigator.language,
    ts: new Date().getTime(), // int
    event: 'pixel_report',
    project: "",
    cid: getParam('pid') || '',
    time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    properties: {
      fbid: getFbPixelId(),
      ip: "",
      client_user_agent: window.navigator.userAgent,
      event_source_url: window.location.href,
      fbp: Cookies.get('_fbp') || "",
      fbc: Cookies.get('_fbc') || "",
    },
    ...data
  }
  console.log('PageView', getFbPixelId())
  window.fbq('init', getFbPixelId());
  window.fbq('track', 'PageView');

  return request({
    url: "/api/v1/report/fb",
    method: "post",
    isToast: false,
    isClearToast: 'none',
    data: {
      ...obj
    },
  })
}

export const fetchTtReport = function (data, type = '') {
  const obj = {
    app_id: getAppID(),
    lan: window.navigator.language,
    ts: new Date().getTime(), // int
    event: 'pixel_report',
    project: "",
    cid: getParam('pid') || '',
    time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    properties: {
      ttid: getTtPixelId(),
      ip: "",
      client_user_agent: window.navigator.userAgent,
      event_source_url: window.location.href,
      ttclid: Cookies.get('ttclid') || "",
      ttp: Cookies.get('_ttp') || "",
    },
    ...data
  }
  if (obj.event === 'pixel_report') {
    if (type === 'PageView') {
      console.log('PageViewTT', getTtPixelId())
      window.ttq.track('PageView');
    }
  }

  return request({
    url: "/api/v1/report/tt",
    method: "post",
    isToast: false,
    data: {
      ...obj
    },
  })
}


// 埋点统计上报
export const fetchReportEvent = function (data = {}) {
  const userId = data.user_id || getStoredUserId()
  const adId = data.idfp || getStoredAdId()
  let extData = {}

  if (data.ext && typeof data.ext === 'string') {
    try {
      const parsedExt = JSON.parse(data.ext)
      extData = parsedExt && typeof parsedExt === 'object' && !Array.isArray(parsedExt)
        ? parsedExt
        : { value: parsedExt }
    } catch (error) {
      extData = { value: data.ext }
    }
  } else if (data.ext && typeof data.ext === 'object') {
    extData = data.ext
  }

  return request({
    url: "/api/v1/data/receive",
    method: "post",
    isToast: false,
    isClearToast: 'none',
    data: {
      ...data,
      app_id: getAppID(),
      user_id: userId,
      idfp: adId,
      ext: JSON.stringify({
        ...extData,
        url: window.location.href
      })
    },
  })
}


export const fetchAirwallexPaymentSession = function(data){
  return request({
    url: '/api/v1/order/payment_session',
    method: 'post',
    isToast: false,
    data,
  })
}
